const breakpointToNumber = (breakpoint: string) =>
  +breakpoint.replace("px", "");

export default breakpointToNumber;
